console.log('jura theme - scripts.js');

